import React from "react";
import { Row, Divider, Typography } from "antd";

import Item from "./Item";

import "./index.less";

const { Text, Link } = Typography

export default ({
  section,
  type,
  image,
  image_title,
  image_alt,
  title,
  content,
  items,
}) => {
  const children = [];
  const sortedItems = items.sort((a, b) => a.sorter - b.sorter);

  for (const item of sortedItems) {
    children.push(<Item {...{ type, ...item }} />);
  }

  let listLayout = (
    <div>
          <Divider orientation="left" orientationMargin="0">
       <Text strong>{title}</Text>
    </Divider>
      <ul className={`listing__${type}`}>{children}</ul>
    </div>
  );

  if (type === "list-partner") {
    listLayout = (
      <Row className={`listing__${type}`} justify="start">
        {children}
      </Row>
    );
  } else if (type === "OTHER-CUSTOM-TYPE-HERE") {
    listLayout = <Row className={`listing__${type}`}>{children}</Row>;
  }

  return <section className="listing">{listLayout}</section>;
};
